import { base, images } from "virtual:static-images";

function findImage(src: string) {
  if (!base || !src.startsWith("/") || src.startsWith("//") || src.includes("\\")) return;
  const source = new URL(src, "https://local.invalid");
  const entry = images[source.pathname];
  if (entry) return { source, entry };
}

export function resolveStaticImage(src: string, width?: number): string {
  const found = findImage(src);
  if (!found) return src;
  const { source, entry } = found;
  const target = new URL(`${base.replace(/\/+$/, "")}/${entry.objectKey.split("/").map(encodeURIComponent).join("/")}`);
  target.search = source.search;
  target.hash = source.hash;
  target.searchParams.delete("x-oss-process");
  if (entry.processable && entry.width && Number.isInteger(width) && width! > 0) {
    target.searchParams.set("x-oss-process", `image/resize,w_${Math.min(width!, entry.width)},limit_1/format,webp`);
  }
  return target.href;
}

export function staticImageCandidates(src: string, requestedWidths: readonly number[]): string | undefined {
  const found = findImage(src);
  if (!found?.entry.processable || !found.entry.width) return;
  const originalWidth = found.entry.width;
  const widths = [...new Set(requestedWidths.filter((width) => Number.isInteger(width) && width > 0)
    .map((width) => Math.min(width, originalWidth)))].sort((a, b) => a - b);
  return widths.length ? widths.map((width) => `${resolveStaticImage(src, width)} ${width}w`).join(", ") : undefined;
}
